// extracted by mini-css-extract-plugin
export default {"inputContainer":"otpVerifier_inputContainer__5qF+j","inputWrapper":"otpVerifier_inputWrapper__-3wP2"};